/**
 * Store sub context for auth data
 */
import { AuthUserProps, UserAuthorizationProps } from '../../config/interfaces';

const AuthContext = {
  authorizedUser: {} as AuthUserProps,
  sessionId: '',
  user34: '',
  userAuthorization: [] as UserAuthorizationProps[],
  employeesDelegatedTo: []
};

export default AuthContext;
